<template>
  <div>
    <div v-if="type === CommentContentType.PARAGRAPH">
      <p>
        <slot></slot>
      </p>
    </div>
    <div v-else-if="type === CommentContentType.BULLET_LIST">
      <ul>
        <slot></slot>
      </ul>
    </div>
    <div v-else>
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { CommentContentType } from "@/models/jiraIssue/jiraIssue.types"

  export default defineComponent({
    props: {
      type: {
        type: String as PropType<CommentContentType>,
        default: "",
        required: false,
      },
    },
    computed: {
      CommentContentType() {
        return CommentContentType
      },
    },
  })
</script>
